export const INSIGHTS_MAX_ACTORS_PER_TASK_PACKAGE = 24;
